<script>
import Card from '@/components/ui/Card.vue';
import ChartSeriesGuide from '@/components/common/ChartSeriesGuide.vue';
import DonutChart from '@/components/common/DonutChart.vue';
import chartColors from '@/components/common/chart-colors';
import { format as formatNumber } from '@/utils/number';

export default {
  name: 'CampaignsDonutCharts',
  components: { DonutChart, Card, ChartSeriesGuide },
  props: {
    charts: {
      type: Array,
      default: () => [],
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    labels() {
      if (!this.campaigns?.length) return [];
      return this.campaigns.map(({ name }) => name);
    },
    colors() {
      return chartColors;
    },
    chartGuideItems() {
      return this.campaigns.map((campaign, index) => ({
        name: campaign.name,
        color: this.colors[index],
      }));
    },
  },
  methods: {
    generateTitleHtml(title, value) {
      const normalizedValue = formatNumber(Math.round(value));
      return `<div style="white-space: nowrap;font-size: 12px;">${title}</div>
                <strong style="font-size: 20px">${normalizedValue}</strong>`;
    },
  },
};
</script>

<template>
  <Card class="reporting-ratio-charts" :loading="loading">
    <div class="reporting-ratio-charts__charts">
      <DonutChart
        v-for="chart in charts"
        :key="chart.title"
        :values="Object.values(chart.campaignsData)"
        :labels="labels"
        :title-html="generateTitleHtml(chart.title, chart.overall)"
        :size="200"
      />
    </div>

    <ChartSeriesGuide :series="chartGuideItems" readonly class="mt" />
  </Card>
</template>

<style lang="scss">
.reporting-ratio-charts {
  &__charts {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
